// extracted by mini-css-extract-plugin
export default {"container":"CommandButton_container__IPdic","pressed":"CommandButton_pressed__LDSJ5","disabled":"CommandButton_disabled__bf8Y3","text":"CommandButton_text__yXs2+"};